import React from 'react';
import { Trans } from 'react-i18next';
import { ROUTE } from 'constants/route';
import { SettingRouteType } from 'constants/settings';
import PatternIcon from '@mui/icons-material/Pattern';
import RegistrationSetting from '../components/RegistrationSetting';

export const settingRouteRegistration: SettingRouteType[] = [
  {
    path: ROUTE.REGISTRATION_SETTING,
    label: <Trans>REGISTRATION.MODEL_TITLE</Trans>,
    icon: <PatternIcon />,
    component: <RegistrationSetting />,
  }
];
